<template>
  <div id="feature-body">
    <div v-bind:class="['feature-wrapper', getLanguageCss()]">
      <div class="potTabArea col" v-if="tabs.length > 1">
        <ul class="tabBar row">
          <a
              v-for="(tab,index) in tabs"
              v-bind:key="index"
              v-bind:class="['tab-button', { active: activeJackpotId === tab }]"
              class="tabBar-button"
              v-on:click.prevent="changeActiveTab(tab, index)"
              :href="getTabUrl(routeKeyMapping.get(tab))"
          >
          {{ tagName(tab) }}
          <!-- for section view GA below-->
          <span v-show="tab === activeJackpotId" :data-section="tab" :active-section="`feature-ga-${index}`" style="position: absolute; top: 0; left: 0;"
                v-gtm:event="'games'"
                v-gtm:gtmAction="'View'"
                v-gtm:gtmCategory="'Gamelobby'"
                v-gtm:gtmLabel="'Gamelobby_Section_'+ RemoveSpecialText(routeKeyMapping.get(tab)) +'_view'"
                v-gtm:@view>&nbsp;</span>
          </a>
        </ul>
      </div>
    </div>
    <div style="position: relative;margin-top: 14px;" id="feature-game-body">
      <template v-for="(jackpotGames) in gameList">
        <template v-for="(game) in jackpotGames.games">
          <div v-show="jackpotGames.category == activeJackpotId" class="jp-game">
            <div v-if="IsBsi() && !game.IsPlayForFun" :onclick="`sendGameIconClickGaEvent(${!IsBsi()},'${game.GameNameEN}')`"
                   data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`"
                   :class="`${game.GameCategoryClass} ${game.GamePresentationClass} feature-game-item`">
                <div data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`"
                     :class="`GameImg GameImg${game.GameCode}-${game.ImgLangCss}`" :title="`${game.GameName}`">
                  <div class="GameIconMask"></div>
                  <img data-view="BSI" class="GameIcon featureLazy" :data-src="`${newCdnUrl}${game.IconPath}&v=${imgVersion}`"
                       :src="`${cdnUrl}/images/base/transparent.png`" :alt="`${game.GameName}`">
                </div>
                <span data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`"
                      class="gameName">{{ game.GameName }}</span>
                <a data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`" class="gameReal needLoginToPlay"><span
                    data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`">{{ $t('requiredLogin') }}</span></a>
            </div>
            <div v-else-if="IsBsi() && game.IsPlayForFun"
                 data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`"
                 :class="`${game.GameCategoryClass} ${game.GamePresentationClass} feature-game-item`" :onclick="`openPlayForFun(${game.GameCode}, '${game.GameNameEN}')`">
              <div data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`"
                   :class="`GameImg GameImg${game.GameCode}-${game.ImgLangCss}`" :title="`${game.GameName}`">
                <div class="GameIconMask"></div>
                <img data-view="BSI" class="GameIcon featureLazy" :data-src="`${newCdnUrl}${game.IconPath}&v=${imgVersion}`"
                     :src="`${cdnUrl}/images/base/transparent.png`" :alt="`${game.GameName}`">
              </div>
              <span data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`"
                    class="gameName">{{ game.GameName }}</span>
              <a data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`" class="gameReal"><span
                  data-ga="openGame" :data-filter="activeJackpotId" data-view="BSI" :data-value="`${game.GameNameEN}`">{{game.PlayButtonStr}}</span></a>
            </div>

            <div v-else-if="!game.IsEnabled && game.IsTestAccount"
                 data-ga="openGame" :data-filter="activeJackpotId" :class="`${game.GameCategoryClass} ${game.GamePresentationClass} feature-game-item`"
                 :onclick="`${playGameFunction(game)}`" :data-value="`${game.GameNameEN}`">
              <div :data-value="`${game.GameNameEN}`"
                   :class="`GameImg GameImg${game.GameCode}-${game.ImgLangCss} GameImgMask`"
                   :title="`${game.GameName}`">
                          <span :data-value="`${game.GameNameEN}`" class="GameGreyTextN">
                          <strong
                              :data-value="`${game.GameNameEN}`">{{ availableSoonText }}</strong><br/>{{
                              playForRealText
                            }}
                          </span>
                <div class="GameIconMask"></div>
                <img data-view="ASI" class="GameIcon featureLazy" :data-src="`${newCdnUrl}${game.IconPath}&v=${imgVersion}`"
                     :src="`${cdnUrl}/images/base/transparent.png`" :alt="`${game.GameName}`">
              </div>
              <span :data-value="`${game.GameNameEN}`" class="gameDisabled">{{ game.GameName }}</span>
            </div>

            <div v-else-if="!game.IsEnabled" :onclick="`sendGameIconClickGaEvent(${!IsBsi()},'${game.GameNameEN}')`"
                 data-ga="openGame" :data-filter="activeJackpotId" :class="`${game.GameCategoryClass} ${game.GamePresentationClass} feature-game-item`">
              <div :data-value="`${game.GameNameEN}`"
                   :class="`GameImg GameImg${game.GameCode}-${game.ImgLangCss} GameImgMask`"
                   :title="`${game.GameName}`">
                              <span :data-value="`${game.GameNameEN}`" class="GameGreyTextN">
                              <strong
                                  :data-value="`${game.GameNameEN}`">{{
                                  availableSoonText
                                }}</strong><br/>{{ playForRealText }}
                              </span>
                <div class="GameIconMask"></div>
                <img data-view="ASI" class="GameIcon featureLazy" :data-src="`${newCdnUrl}${game.IconPath}&v=${imgVersion}`"
                     :src="`${cdnUrl}/images/base/transparent.png`" :alt="`${game.GameName}`">
              </div>
              <span :data-value="`${game.GameNameEN}`" class="gameDisabled">{{ game.GameName }}</span>
            </div>

            <div v-else
                 data-ga="openGame" :data-filter="activeJackpotId" data-view="ASI" :data-value="`${game.GameNameEN}`"
                 :class="`${game.GameCategoryClass} ${game.GamePresentationClass} feature-game-item`"
                 :onclick="`${playGameFunction(game)}`">
              <div data-ga="openGame" :data-filter="activeJackpotId" data-view="ASI" :data-value="`${game.GameNameEN}`"
                   :class="`GameImg GameImg${game.GameCode}-${game.ImgLangCss}`" :title="`${game.GameName}`">
                <div class="GameIconMask"></div>
                <img data-view="ASI" class="GameIcon featureLazy" :data-src="`${newCdnUrl}${game.IconPath}&v=${imgVersion}`"
                     :src="`${cdnUrl}/images/base/transparent.png`" :alt="`${game.GameName}`">
              </div>
              <span data-ga="openGame" :data-filter="activeJackpotId" data-view="ASI" :data-value="`${game.GameNameEN}`"
                    class="gameName">{{ game.GameName }}</span>
              <a data-ga="openGame" :data-filter="activeJackpotId" data-view="ASI" :data-value="`${game.GameNameEN}`" class="gameReal"><span
                  data-ga="openGame" :data-filter="activeJackpotId" data-view="ASI" :data-value="`${game.GameNameEN}`">{{ playForRealText }}</span></a>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import i18n from './lang/i18n';

export default {
  name: 'featureBody',
  components: {},
  data: function () {
    return {
      currentTab: 0,
      tabs: [],
      gameList: {}
    }
  },
  mounted() {
    i18n.locale = Cookies.get('lang').replace('-','_').toLowerCase();
  },
  methods: {
    changeActiveTab: function (id, index) {
      this.currentTab = index;
      this.$store.commit('setActiveJackpotId', id);
      window.history.replaceState({}, '', this.getTabUrl(this.routeKeyMapping.get(id)) );
    },
    tagName(id) {
      return id;
    },
    playGameFunction(game) {
      if(game.is)

      if (game.OpenGameFunction == "virtualSport") {
        return `window.location.href = '/products/virtualsports/?${game.VirtualSportParameters}'`;
      }

      let playForReal = `openPlayForRealWithLicenseCheck(${game.GameCode},'${game.gameCategory}',${game.ServiceProvider},'${game.GameName.replace(/'/g, '')}',${game.GameFrom},'${game.LanguageCode}',${game.ShowIomAlert})`;
      return game.IsEnabled || game.IsTestAccount ? playForReal : "";
    },
    getTabUrl: function (tab) {
      return `${window.location.origin}${this.getConvertedLanguage()}/games/feature/${tab}`
    },
    getLanguageCss(){
      try {
        return Cookies.get('lang').replace('_','-').toLowerCase().toString();
      }
      catch (error) {
        console.error('Error getLanguageCss:', error.message);
        return '';
      }
    },
    getConvertedLanguage(){
      let lang = Cookies.get('lang').replace('_','-').toLowerCase();

      if (lang === "en"){
        return "";
      }

      const splitLanguage = lang.split('-');
      splitLanguage[1] = splitLanguage[1].toUpperCase();
      return `/${splitLanguage[0]}-${splitLanguage[1]}`;
    },
    IsBsi(){
      return this.$store.state.isBsi;
    },
    RemoveSpecialText : function(value){
      return value.replaceAll(' ','');
    }
  },
  computed: {
    isInitFinished: function () {
      return this.$store.state.isGetGameListFinished;
    },
    activeJackpotId: function () {
      return this.$store.state.activeJackpotId;
    },
    cdnUrl: function () {
      return this.$store.state.cdnUrl;
    },
    newCdnUrl: function () {
      return this.$store.state.newCdnUrl;
    },
    imgVersion: function () {
      return this.$store.state.imgVersion;
    },
    availableSoonText: function () {
      return this.$store.state.availableSoonText;
    },
    playForRealText: function () {
      return this.$store.state.playForRealText;
    },
    routeKeyMapping: function () {
      return this.$store.state.routeMapping;
    }
  },
  watch: {
    isInitFinished: function (isFinish) {
      if (isFinish) {
        this.tabs = this.$store.state.jackpotInfos;
        this.gameList = this.$store.state.jackpotGames;

        var options = {
          rootMargin: '300px',
          threshold: 0.5
        }
        $(function () {
          var watcher = new IntersectionObserver(onEnterView, options);
          var lazyImages = document.querySelectorAll('img.featureLazy');

          lazyImages.forEach(image => watcher.observe(image));
          function onEnterView(entries, observer) {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                var img = entry.target;
                img.setAttribute('src', img.getAttribute('data-src'));
               //img.removeAttribute('data-src');
                observer.unobserve(img);
              }
            });
          }
        });
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~@/scss/base/reset";
@import "~@/scss/base/colors";
@import "~@/scss/main";

#feature-game-body {
  width: calc(100% - 20px);
  margin: 0 auto;
}

.potTabArea {
  margin: 2%;
  box-sizing: border-box;

  .tabBar {
    justify-content: flex-start;
    width: 100%;
    padding: 1rem 0;
    background: $potTabButtonBg;

    &-button {
      border-left: 1px solid $potTabButtonBorder;
      font-size: 12px;
      padding: 0 1rem;
      color: $potTabButtonText;
      cursor: pointer;

      &:first-child {
        border-left: none;
      }

      &.active,
      &:active,
      &:hover {
        color: $potTabButtonTextActive;
      }
    }
  }

  .tabContent {
    width: 100%;
    min-height: 350px;
    padding: 1rem 0;
    justify-content: flex-start;
  }
}

#feature-body .jp-game > div {
  position: relative;
}

#feature-body .feature-game-item {
  height: 165px;
}

h3 {
  text-align: center;
  font-size: 0.8rem;
  font-weight: 300;
}

h4 {
  text-align: center;
  font-weight: 100;
  font-size: 0.7rem;
}
</style>
